import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18e0956e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "position-relative",
  style: {"background-color":"#f6faff"}
}
const _hoisted_2 = { class: "container container-90 content-space-t-2 content-space-t-md-2 content-space-t-lg-3" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "mb-5 mt-10" }
const _hoisted_6 = { class: "w-md-75 mb-5" }
const _hoisted_7 = { class: "display-6" }
const _hoisted_8 = { class: "text-primary text-highlight-warning" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "js-text-animation" }, null, -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex-shrink-0" }
const _hoisted_12 = { class: "avatar avatar-circle" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "avatar-img",
  src: "https://htmlstream.com/preview/front-v4.3.1/assets/img/160x160/img1.jpg"
}
const _hoisted_15 = { class: "flex-grow-1 ms-3 mb-0" }
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = { class: "col-lg-6 zi-2" }
const _hoisted_18 = { style: {"text-align":"center","position":"relative","flex-shrink":"3"} }
const _hoisted_19 = { class: "top-0 end-0" }
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "shape shape-bottom zi-1",
  style: {"margin-bottom":"-0.125rem"}
}, [
  /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px","background-color":"white"} })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypedJs = _resolveComponent("TypedJs")!
  const _component_MrUiKitSearch = _resolveComponent("MrUiKitSearch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h1", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.t('home.staticSearch')) + " ", 1),
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_TypedJs, { options: _ctx.options }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["options"])
                ])
              ])
            ]),
            _createVNode(_component_MrUiKitSearch, {
              modelValue: _ctx.search,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
              placeholder: _ctx.t('home.searchBarPlaceholder'),
              iconPosition: 'right',
              searchResults: _ctx.items,
              onOnSearch: _ctx.onSearch,
              infiniteScroll: false
            }, {
              default: _withCtx(({ item }) => [
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.onClick(item)),
                  class: "d-flex align-items-center p-2"
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      (item.photo)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "avatar-img",
                            src: item.photo
                          }, null, 8, _hoisted_13))
                        : (_openBlock(), _createElementBlock("img", _hoisted_14))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h5", _hoisted_16, _toDisplayString(item.fullname), 1)
                  ])
                ], 8, _hoisted_10)
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onShowMoreResults && _ctx.onShowMoreResults(...args))),
                  class: "searchFooter"
                }, _toDisplayString(_ctx.t('common.showMoreResults')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "searchResults", "onOnSearch"])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("img", {
                class: "img-fluid",
                src: _ctx.homeHeroImage
              }, null, 8, _hoisted_20)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_21
  ]))
}